import { Contract } from 'cpfr-common';

type CommonFieldNameType = 'productType' | 'productFamily' | 'productTypeFR' | 'contractNumber';

export const getCommonProductField = (fieldName: CommonFieldNameType, arr?: Contract[]): string => {
    if (!arr?.length) return 'None';

    const uniqueTypes = new Set(arr.map((item) => item[fieldName]));
    if (uniqueTypes.size === 1) {
        return arr[0][fieldName] || 'None';
    }

    return 'Multiple';
};

export const getDeepList = (contracts?: Contract[]): string => {
    if (!contracts || contracts.length <= 1) return '';

    const list = contracts.map((contract, index) => ({
        NR: index + 1,
        ProductTypeFR: contract.productType || '',
        ProductType: contract.productTypeFR || '',
    }));

    // Double-stringify so the value is delivered as an escaped JSON string, not re-parsed to an array by the Chatbot
    return JSON.stringify(JSON.stringify(list));
};
